export { default } from "./src/blog-news-gallery";

export type { UniformBlogNewsGalleryProps } from "./src/blog-news-gallery";
